import ExerciseCardAPI from '@/apis/business/teacher/exercise-card-api.js'

export default {
  namespaced: true,

  state: {
    defaultDiffDay: 2,
    startFile: 1,
    comboExerciseParam: {
      SubjectID: '',
      GradeID: null
    },
    numberDocument: null,
    classAssignment: [],
    classAssignmentDetail: null,
    exerciseCard: {
      ExerciseStore: [],
      RefAttachment: [],
      ClassID: null,
      ClassCode: '',
      ClassName: '',
      SubjectID: '',
      SubjectCode: '',
      SubjectName: '',
      TeacherID: null,
      TeacherName: '',
      GradeID: null,
      GradeName: '',
      QtyQuestion: 0,
      TopicID: null,
      Title: '',
      Deadline: new Date(new Date().setDate(new Date().getDate() + 2)),
      IsSchedule: false,
      ScheduleDate: new Date(),
      SubmitAnswer: 0,
      TotalSubmit: 0,
      IsCompensate: false,
      Message: ''
    },
    isTry: false,
    documents: [],
    giveExerciseDashboard: null,
    routeCompose: null,
    listExerciseSelected: [],
    giveExerciseData: {
      IsSchedule: false, // chọn lịch giao
      ScheduleDate: null, // Ngày giao
      Deadline: null, // ngày hạn nộp,
      SubmitAnswer: 0 // xem đáp án hay ko
    },
    giveExerciseRoute: null
  },

  getters: {
    getClassAssignment (state) {
      return [state.classAssignment[0]]
    },

    getExerciseCard (state) {
      return state.exerciseCard || null
    },

    getComboExerciseParam (state) {
      return state.comboExerciseParam || null
    }
  },

  mutations: {
    setGiveExerciseDataScheduleDate (state, data) {
      state.giveExerciseData.ScheduleDate = data
    },
    setIsTry (state, data) {
      state.isTry = data
    },
    setGiveExerciseDataDeadline (state, data) {
      state.giveExerciseData.Deadline = data
    },
    setGiveExerciseDataIsSchedule (state, data) {
      state.giveExerciseData.IsSchedule = data
    },
    setGiveExerciseDataSubmitAnswer (state, data) {
      state.giveExerciseData.SubmitAnswer = data
    },
    resetRouteComposeAndData (state) {
      state.routeCompose = null
      state.giveExerciseData = {
        IsSchedule: false, // chọn lịch giao
        ScheduleDate: '', // Ngày giao
        Deadline: '', // ngày hạn nộp,
        SubmitAnswer: 0 // xem đáp án hay ko
      }
      state.exerciseCard.Deadline = new Date()
      state.exerciseCard.Deadline.setDate(
        new Date().getDate() + state.defaultDiffDay
      )
      state.exerciseCard.IsSchedule = false
      state.exerciseCard.RefAttachment = []
      state.exerciseCard.ScheduleDate = new Date()
      state.exerciseCard.SubmitAnswer = 0
    },
    setClassAssignmentDetail (state, data) {
      state.classAssignmentDetail = data
    },

    // setGiveExerciseDashboard(state, data){
    //   state.giveExerciseDashboard
    // },
    getExerciseCard (state) {
      return state.exerciseCard || null
    },

    setClassAssignment (state, newValue) {
      state.classAssignment = newValue
    },

    setNumberDocument (state, number) {
      state.numberDocument = number
    },

    setDeadline (state, deadLine) {
      state.exerciseCard.Deadline = deadLine
    },

    setSchedule (state, schedule) {
      state.exerciseCard.ScheduleDate = schedule
    },

    setComboExerciseParam (state, param) {
      state.comboExerciseParam = param
    },

    setStartFile (state, startFile) {
      state.startFile = startFile
    },

    setExerciseCard (state, exerciseCard) {
      state.exerciseCard = exerciseCard
      state.exerciseCard.ExerciseStore = [exerciseCard.ExerciseStore]
    },

    setMessage (state, message) {
      state.exerciseCard.Message = message
    },

    removeDocument (state, fileID) {
      state.exerciseCard.RefAttachment =
        state.exerciseCard.RefAttachment.filter((item) => {
          return item.FileID !== fileID
        })
    },

    setDefaultExerciseCard (state, data) {
      if (!state.routeCompose) {
        state.exerciseCard.Deadline = new Date()
        state.exerciseCard.Deadline.setDate(
          new Date().getDate() + state.defaultDiffDay
        )
        state.exerciseCard.IsSchedule = false
        state.exerciseCard.RefAttachment = []
        state.exerciseCard.ScheduleDate = new Date()
        state.exerciseCard.SubmitAnswer = 0
        state.exerciseCard.IsCompensate = false
        state.exerciseCard.Message = ''
      }

      state.exerciseCard.ExerciseStore = data?.ExerciseStore
      if (!data?.AddAssignment) {
        state.classAssignment = data?.Class
      }
    },

    setDefaultExerciseCardCompensate (state) {
      state.exerciseCard.IsCompensate = false
    },

    addDocument (state, document) {
      state.exerciseCard.RefAttachment =
        state.exerciseCard.RefAttachment.concat(document)
    },

    addExerciseStore (state, exerciseStore) {
      state.exerciseCard.ExerciseStore.push(exerciseStore)
    },

    removeExerciseStore (state, exercise) {
      state.exerciseCard.ExerciseStore =
        state.exerciseCard.ExerciseStore.filter((item) => {
          return item.Id !== exercise.Id
        })
    },
    resetExerciseStore (state) {
      state.exerciseCard.ExerciseStore = []
    },
    setRouteCompose (state, route) {
      state.routeCompose = route
    },
    setGiveExerciseData (state, data) {
      state.giveExerciseData = data
    },
    setExerciseGiveRoute (state, data) {
      state.giveExerciseRoute = data
    }
  },

  actions: {
    addListExerciseCard (context, listExerciseCard) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.postAsync('assignment', listExerciseCard)
          .then((res) => {
            if (res.Data) {
              context.dispatch('getRankingGiftCard', res.Data, { root: true })
            }
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    updateExerciseCard (contetxt, exerciseCard) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.putAsync(`${exerciseCard.Id}`, exerciseCard)
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    getExerciseCardByID (context, id) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.getAsync(`${id}`)
          .then((res) => {
            context.commit('setExerciseCard', res.Data)
            context.commit('setClassAssignment', [res.Data.ClassID])
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Xóa bài tập
     * @param {*} context
     * @param {*} id
     * @returns
     */
    deleteExerciseCardByID (context, id) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.deleteExerciseCard(id)
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
